import React from "react";
import { useIntl } from "react-intl";
import { Route, Routes } from "react-router-dom";

import { WindowTitle } from "../components/WindowTitle";
import BusinessDetailsComponent from "./views/BusinessDetailsPage";

const Component = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle
        title={intl.formatMessage({ defaultMessage: "Business Details" })}
      />
      <Routes>
        <Route path="/" element={<BusinessDetailsComponent />} />
      </Routes>
    </>
  );
};

export default Component;
